exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".score.label {\n  font-size: 110%;\n  padding: 3px 6px;\n  display: inline-block;\n  height: 20px;\n  line-height: 14px;\n}\n.score.label.label-failing {\n  background-color: var(--color-alert-light);\n}\n.score.label.label-failing.inverse {\n  color: var(--color-alert);\n}\n.score.label.label-healthy {\n  background-color: var(--color-success);\n}\n.score.label.label-healthy.inverse {\n  color: var(--color-success);\n}\n.score.label.label-unhealthy {\n  background-color: var(--color-danger);\n}\n.score.label.label-unhealthy.inverse {\n  color: var(--color-danger);\n}\n.score.label.label-unknown {\n  background-color: var(--color-text-caption);\n}\n.score.label.label-unknown.inverse {\n  color: var(--color-text-caption);\n}\n.score.label.inverse {\n  background-color: transparent;\n  font-size: 100%;\n  padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/canary/canary/canaryScore.component.less
// module id = 3767
// module chunks = 0